<template>
  <div>
    <div class="box margin">
      <div class="font-style">章节名称： {{LessonName}}</div>
      <div class="mar-lef">章节时长： {{playDuration}}</div>
      <div class="mar-lef">学习时长： {{watchDuration}}</div>
    </div>
    <div class="box margin">
      <div class="font-style">最近学习时间： {{newWatchTime}}</div>
    </div>
    <div class="box margin">
      <div class="font-style lesson_ins">
          <div>章节介绍： </div>
          <div class="lesson_ins_div">
              {{remark}}
          </div>
      </div>
    </div>
    <div class="box margin">
        <div class="font-style video-box-parent">
          <div>视频： </div> 
          <div style="margin-left:30px;">
            <!-- :src= item.fileUrl -->
            <video
              id="videoComponent"
              :src= currentFileUrl
              style="width:800px;height:400px;"
              controls
              controlsList="nodownload"
              oncontextmenu="return false;"
              :disablePictureInPicture="true"
              @play="trainLessonStart(fastForwardFlg == '0' ? false : true)"
              @pause="trainLessonStop()"
              class="video-border"
            >
            </video>
            <!-- <div class="">进度：{{currentLearnRate}}</div> -->
          </div>
          <div class="list-border" style="margin-left:20px;height:400px;overflow-y:auto;">
            <div @click="lessonFileId == item.fileId ? '': videoClickFun(item)" class="video-list" v-for="(item,index) in lessonFileItemList" :key="index">
              <div :class="['marginLeft',item.fileId == lessonFileId ? 'playFlag' : '']">视频{{index+1}}&nbsp;&nbsp;(进度：{{item.learnRate}})</div>
            </div>
          </div>
      </div>
    </div>
    <div class="box back-btn">
        <BBtnPrimary :clicked="back" btn-txt="返回"/>
    </div>
  </div>
</template>
<script>
import {trainLessonDetail, trainLessonFileSave, lessonFileDetail } from "@/api/stuLessonManagement";
import BBtnPrimary from "../../components2/BBtnPrimary";
export default {
  name: "CourseManagement",
  components: {
      BBtnPrimary,
  },
  data() {
    return {
      totalPages: 0,
      page: 1,
      limit: 10,
      totalCount: 0,
      searchParam: {},
      // 专业List
      trainMajorList: [],
      // 回放List
      playBackList: [],
      // 状态List
      statusList: [],
      // 课程List
      courseList: [],
      // 总课时
      courseHoursTotal: 0,
      // 课程数量
      courseNum: 0,
      // 删除message
      deleteMessage: "",
      // 删除dialog
      deleteDialog: false,
      // 章节id
      lessonId: null,
      createTime: {
        from: "",
        to: "",
      },
      data:{},
      deleteId:'',
      roleType: sessionStorage.getItem('roleType'),
      navi: [
        {name: "stu-lesson-management-detail"},
      ],
      LessonName: "",
      lessonFileItemList: [],
      timer: null,
      tempTimer: null,
      remark: "",
      newWatchTime: "",
      playDuration: "",
      watchDuration: "",
      lessonFileLookList: [],
      index: "",
      lookFlg: true,
      fastForwardFlg: "",
      old_id: "",
      currentFileUrl: '',
      currentLearnRate: '',
      currentWatchTimeMax: 0,
      currentWatchTime: 0,
      classId: null,
      lessonFileId: null,
      currentPlayTime: 0,
      inter: '',
      data_historyWatchTimeMax: 0,
    };
  },
  created() {
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
      sessionStorage.removeItem("store");
    }
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
  },
  
  // 页面载入之前
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      const params = {
          lessonId : vm.$route.params.lessonId,
          classId : vm.$route.params.classId
      };
      if (
          params.lessonId !== null &&
          params.lessonId !== "" &&
          params.lessonId !== undefined
      ) {
          // 把不为空的参数存入缓存
          vm.$store.commit("SET_TRAIN_LESSON_ID", params);
      }
      // 参数赋值
      if (
          vm.$store.state.classManagement_lessonId !== undefined &&
          vm.$store.state.classManagement_lessonId !== null &&
          vm.$store.state.classManagement_lessonId !== ""
      ) {
          vm.classId = vm.$store.state.classManagement_classId;
          vm.lessonId = vm.$store.state.classManagement_lessonId;
      }
    });
  },
  mounted () {
    this.init(this.classId, this.lessonId)
  },
  methods: {
    // 点击视频清单
    videoClickFun (item) {
      this.lessonFileId = item.fileId
      this.getVideoDetail(item.fileId)
      // 切换视频 重新计时save
      clearInterval(this.inter)
      //刷新清单进度
      this.updateProcess()
    },
    async getFileDetail (flag,fileId) {
      const data = await lessonFileDetail(this.classId,fileId,"")
      if (flag) {
        //历史最大播放时间
        this.currentWatchTimeMax = data.data.watchTimeMax
        // url
        this.currentFileUrl = data.data.fileUrl
        // 比特率
        this.currentLearnRate = data.data.learnRate
        //视频总时长
        this.currentPlayTime = data.data.playTime
        //上次播放时间
        this.currentWatchTime = data.data.watchTime
        //自动开始播放
      } else {
        var videoEle = document.getElementById("videoComponent")
        videoEle.currentTime = data.data.watchTimeMax
        //videoEle.currentTime = this.currentWatchTimeMax
      }
    },
    //获得视频的播放信息
    async getVideoDetail (fileId) {
      this.getFileDetail(true,fileId)
      const that = this
      setTimeout(() => {
        var videoEle = document.getElementById("videoComponent")
        // 视频切换时 加载至视频的最大播放时长
        videoEle.currentTime = that.currentWatchTimeMax
        videoEle.play()
      }, 500);
    },
    // 初始化
    async init(classId,lessonId) {
        const data = await trainLessonDetail(classId, lessonId, "");
        this.LessonName = data.data.trainLessonName
        this.lessonFileItemList = data.data.lessonFileItemList
        this.lessonFileItemList.push()
        this.remark = data.data.remark
        this.newWatchTime = data.data.newWatchTime
        this.playDuration = data.data.playDuration
        this.watchDuration = data.data.watchDuration
        this.fastForwardFlg = data.data.fastForwardFlg
        //videoId
        this.lessonFileId = this.lessonFileItemList[0].fileId
        //视频总时长
        this.currentPlayTime = this.lessonFileItemList[0].playTime
        //历史最长播放时间
        this.currentWatchTimeMax = this.lessonFileItemList[0].watchTimeMax
        //上次播放时间
        this.currentWatchTime = this.lessonFileItemList[0].watchTime
        // 初始化时默认展示第一个视频
        const that = this
        setTimeout(() => {
          var videoEle = document.getElementById("videoComponent")
          that.currentFileUrl = that.lessonFileItemList[0].fileUrl
          // 初始化时 加载至视频的最大播放时长
          videoEle.currentTime = that.lessonFileItemList[0].watchTimeMax
          that.currentLearnRate = that.lessonFileItemList[0].learnRate
        }, 1000);
    },
    // 暂停
    trainLessonStop() {
      const that = this
      //暂停时 保存定时器清除
      for (var i=0; i<=this.inter; i++) {
        clearInterval(i)
      }
      var videoEle = document.getElementById("videoComponent")
      if (!videoEle) {
        return;
      }
      var currentPlayTime = videoEle.currentTime
      if (currentPlayTime >= that.currentPlayTime) {
        setTimeout(() => {
          that.fun()
        }, 500);
        setTimeout(() => {
          //视频播放完毕时，持久化时间
          if ((Number(currentPlayTime) - Number(that.data_historyWatchTimeMax)) > 7.5) {
            videoEle.currentTime = that.data_historyWatchTimeMax
            videoEle.play()
          } else {
            if (currentPlayTime >= that.currentPlayTime) {
              if (videoEle != null) {
                var param = {
                  classId: that.classId,
                  lessonId: that.lessonId,
                  fileId: that.lessonFileId,
                  watchTime: videoEle.currentTime,
                };
                console.log("视频播放完毕,时间正在保存...")
                that.trainLessonSave(param)
              }
            }
          }
        }, 1000);
      }
      //刷新清单进度
      setTimeout(() => {
        this.updateProcess()
      }, 4000);
    },
    async fun () {
      const data = await lessonFileDetail(this.classId, this.lessonFileId, "")
      this.data_historyWatchTimeMax = data.data.watchTimeMax
    },
    // 视频开始播放时调用方法
    async trainLessonStart(fastFlg) {
      const that = this
      var videoEle = document.getElementById("videoComponent")
      var currentPlayTime = videoEle.currentTime
      console.log("允许快进？"+fastFlg)
      // 如果 视频已经播放完了 点击时自动从头播放
      // if (videoEle.currentTime >= this.currentPlayTime) {
      //   videoEle.currentTime = this.currentPlayTime
      // }
      // 只要开始播放 就每5s保存一次时间
      this.inter = setInterval(() => {
        var param = {
          classId: that.classId,
          lessonId: that.lessonId,
          fileId: that.lessonFileId,
          watchTime: videoEle.currentTime,
        };
        console.log("5s-save")
        that.trainLessonSave(param)
      }, 5000);
      // 视频不允许快进的情况
      if (!fastFlg) {
        // 快进时 从数据库取得历史最大播放时长
        const data = await lessonFileDetail(this.classId,this.lessonFileId,"")
        var historyWatchTimeMax = data.data.watchTimeMax
        // 当前播放时间 大于 历史最大播放时间时 回滚进度条至 历史播放最远处
        if (currentPlayTime >= historyWatchTimeMax) {
          this.getFileDetail(false,this.lessonFileId)
        } else {
          // 更新 watchTime（此处watchTime 肯定是 小于 historyMaxTime）
          var param = {
            classId: that.classId,
            lessonId: that.lessonId,
            fileId: that.lessonFileId,
            watchTime: videoEle.currentTime,
          };
          console.log("-----小于最大播放时间save------")
          that.trainLessonSave(param)
        }
      }
    },
    // 更新观看时间
    async trainLessonSave(param) {
      const dataTimes = await trainLessonFileSave(param);
      console.log("save success"+dataTimes)
    },
    // 更新视频清单的进度
    async updateProcess () {
      const data = await trainLessonDetail(this.classId,this.lessonId,"");
      this.lessonFileItemList = data.data.lessonFileItemList
      this.newWatchTime = data.data.newWatchTime
      this.watchDuration = data.data.watchDuration
    },
    back () {
      this.$router.push({
          name: "stu-lesson-management",
      });
    }
  },
};
</script>

<style scoped>
.main2 {
  position: relative;
  /*margin: 5px 30px 5px 30px;*/
  padding-top: 28px;
  display: flex;
  flex-wrap: wrap;
}

.search-result {
  display: block;
  position: relative;
  margin: 30px 25px 5px 25px;
}

.search-functions-headers {
  position: relative;
  display: flex;
  justify-content: space-between;
  top: 0;
}

.search-functions {
  position: relative;
  top: 0;
  display: flex;
}

.search-result-summary {
  display: flex;
  align-items: center;
}

.search-result-summary .summary {
  margin: 0 50px 0 0;
}

.search-result-table {
  border-spacing: 0px;
  padding-bottom: 50px;
  width: 100%;
  margin-top: 10px;
}

.table-header-row {
  height: 67px;
  background: #f6f6f6;
}

.table-header-row th {
  text-align: left;
  padding: 10px;
}

.table-result-row {
  height: 78px;
  font-weight: 500;
  color: #333333;
}

.table-result-row td {
  border-bottom: 1px solid #ebebeb;
  padding: 10px;
  text-align: left;
}

.btn-detail {
  margin: 0 20px 0 20px;
  color: #0171a3;
  cursor: pointer;
}

.btn-delete {
  color: #fd1f58;
  cursor: pointer;
}
.box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.box-left {
  border-top: 1px solid black;
  border-bottom: 1px solid black;
  border-right: 1px solid black;
}

.box-right {
  border-top: 1px solid black;
  border-bottom: 1px solid black;
}
.timeDiscount{
  white-space: pre-line;
}

.mar-lef {
  margin-left: 180px;
  color: #333333;
}

.font-style {
    margin-left: 40px;
    color: #333333;
}

.margin {
    margin-top: 20px;
    margin-bottom: 20px;
}

.lesson_ins {
    display: flex;
    flex-direction: row;
}

.lesson_ins_div {
    width: 600px;
    height: auto;
}

.back-btn {
    display: flex;
    flex-direction: row;
    justify-content: left;
    margin-left: 70px;
}
.video-box {
  display: flex;
  justify-content: flex-start;
  max-height: 362px;
  min-height: 0px;
  margin: 0px 20px 20px 20px;
  overflow: auto;
  overflow-x: hidden;
}
.learnProgress {
  position: relative;
  top: -325px;
  left: 600px;
}

.video-box-parent {
  display: flex;
  width: 100%;
}

.video-list {
  display: flex;
  flex-direction: row;
  width: 300px;
  height: 40px;
  background: #f4f4f4;
  margin-bottom: 9px;
  cursor: pointer;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
}

.playFlag {
  color: rgb(43, 115, 223);
}

.marginLeft {
  margin-left: 10px;
  -webkit-user-drag: none;
  -webkit-user-select: none;
}

.list-border {
  border: 1px solid black;
  border-radius: 10px;
  -webkit-user-drag: none;
}

.video-border {
  border: 1px solid black;
  border-radius: 10px;
}
</style>
